export default "__VITE_ASSET__psFqJKll__"